import React, { useState, useEffect } from "react";
import "./TypeWriterText.css"; // Import the new CSS file

/**
 * TypewriterText component.
 * Animates text character by character.
 * @param {string} text - The text content to display.
 * @param {number} delay - Delay between typing each character (in ms).
 */
function TypewriterText({ text, delay = 50 }) {
  const [displayText, setDisplayText] = useState("");
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    // Only proceed if there is text and we haven't finished typing
    if (currentIndex < text.length) {
      const timeout = setTimeout(() => {
        setDisplayText((prevText) => prevText + text[currentIndex]);
        setCurrentIndex((prevIndex) => prevIndex + 1);
      }, delay);

      // Cleanup function to clear the timeout if the component unmounts
      return () => clearTimeout(timeout);
    }
    // Dependency array ensures the effect runs when text, delay, or currentIndex changes
  }, [text, delay, currentIndex]);

  return (
    <span className="typewriter-text-container">
      {/* Display the accumulated text */}
      {displayText}
      {/* Conditionally display the animated cursor only while typing */}
      {currentIndex < text.length && (
        <span className="typewriter-cursor">|</span>
      )}
    </span>
  );
}

export default TypewriterText;
